<template>
	<v-tooltip bottom>
		<template #activator="{ on }">
			<v-btn
				small
				icon
				color="gray"
				v-on="on"
				@click="onClick"
			>
				<v-icon dark>
					mdi-{{ icon }}
				</v-icon>
			</v-btn>
		</template>
		<span>{{ tooltipText }}</span>
	</v-tooltip>
</template>

<script>
export default {
	name: "RemoveBtn",
	components: {},
	props: {
		data: { type: [Object, String, Number], required: false, default: null },
		options: {
			type: Object,
			default: () => {
				return {};
			},
		},
		tooltipText: { type: String, default: "מחיקה" },
		icon: { default: "delete", type: String },
	},
	data () {
		return {};
	},
	computed: {},
	methods: {
		onClick () {
			this.$emit("click", this.data);
			this.$notfication.warning(undefined, undefined, this.options).then((event) => {
				if (event.value) {
					this.$emit("remove", event.value);
				}
			});
		},
	},
};
</script>

<style scoped>
	button {
		/*float: left;*/
	}

	.red-color {
		color: #cccccc !important;
	}
</style>
